const treatmentMappingKeys = {
    list: (
      cancerPathologyId: string,
      treatmentTypeId: string,
    ) => ['treatmentMappings', 'list', cancerPathologyId, treatmentTypeId]
  }
  
  export { treatmentMappingKeys };
  